import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-ui',
  template: `
    <div class="block-ui" *ngIf="loading">
      <section class="block-ui-message">
        <i
          class="pi pi-spin pi-spinner mb-3"
          style="font-size: 2rem; font-weight: bold"
        ></i>
        <h2 class="p-text-center">
          <ng-content></ng-content>
        </h2>
      </section>
    </div>
  `,
  styleUrls: ['./block-ui.component.scss'],
})
export class BlockUiComponent implements OnInit {
  /**
   * * Inputs
   */
  @Input() loading = false;
  constructor() {}

  ngOnInit(): void {}
}
